import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

//Services
import AuthService from "@/services/AuthService";
import Notie from "@/services/NotieService";

//Pages
import Home from "@/vues/Home";
import Login from "@/vues/Login";
import Invite from "@/vues/Invite";
import Signup from "@/vues/Signup";
import Portfolio from "@/vues/Portfolio";

import DistrictSelect from "@/vues/DistrictSelect"
import ClassList from "@/vues/ClassList"
import ClassDetails from "@/vues/ClassDetails"

import Profile from "@/vues/Profile";
import ProfileList from "@/vues/ProfileList"
import ProfileEntry from "@/vues/ProfileEntry"
import ProfileResult from "@/vues/ProfileResult"
import PitchEntry from "@/vues/PitchEntry"
import Pitches from "@/vues/Pitches";
import PrototypeEntry from "@/vues/PrototypeEntry";
import InnovationCanvas from "@/vues/InnovationCanvas";
import CanvasEdit from "@/vues/CanvasEdit";
import CanvasFeedback from "@/vues/CanvasFeedback";
import Canvases from "@/vues/Canvases"
import TVREntry from "@/vues/TVREntry";
import TVRPicker from "@/vues/TVRPicker"
import TVRForm from "@/vues/TVRForm"
import TVRResults from "@/vues/TVRResults"
import TVRFeedbacks from "@/vues/TVRFeedbacks"
import TVRFeedback from "@/vues/TVRFeedback"
import Video from "@/vues/Video";
import ProficiencyExam from "@/vues/ProficiencyExam";

import Pitch from "@/vues/Pitch"
import UploadPitch from "@/vues/UploadPitch"
import PitchProgress from "@/vues/PitchProgress";
import PrototypeProgress from "@/vues/PrototypeProgress";
import PitchSubmission from "@/vues/admin/PitchSubmission";
import CanvasSubmission from "@/vues/admin/CanvasSubmission";
import SectionService from "../services/SectionService";

import AdminLanding from "@/vues/admin/AdminLanding"
import UserListing from "@/vues/admin/UserListing"
import UserEdit from "@/vues/admin/UserEdit"

import DistrictListing from "@/vues/admin/DistrictListing"
import DistrictEdit from "@/vues/admin/DistrictEdit"

import ActivityListing from "@/vues/admin/ActivityListing"

import ProgramListing from "@/vues/admin/ProgramListing"
import ProgramEdit from "@/vues/admin/ProgramEdit"

import SchoolListing from "@/vues/admin/SchoolListing"
import SchoolEdit from "@/vues/admin/SchoolEdit"

import SectionListing from "@/vues/admin/SectionListing"
import SectionEdit from "@/vues/admin/SectionEdit"

import ContestListing from "@/vues/admin/ContestListing"
import ContestEdit from "@/vues/admin/ContestEdit"

import ScorePortfolios from "@/vues/admin/ScorePortfolios"

import UploaderTest from "@/vues/admin/UploaderTest"

import UserAccountEdit from "@/vues/UserAccountEdit";

const RoleAdmin = "ADMIN"
const RoleTeacher = "TEACHER"
const RolePartner = "PARTNER"
const RoleStudent = "STUDENT"
const RoleJudge = "JUDGE"
// const RoleNone = ""

const router = new Router({
	routes: [
		{
			path: "/",
			name: "Home",
			component: Home,
			props: initProps,
		},
		{
			path: "/login",
			name: "Login",
			component: Login,
			props: initProps,
		},
		{
			path: "/login/:role/:code",
			name: "Invite",
			component: Invite,
			props: initProps,

		},
		{
			path: "/signup",
			name: "Signup",
			component: Signup,
			props: initProps,
		},
		{
			path: "/district_select",
			name: "DistrictSelect",
			component: DistrictSelect,
			props: initProps,
		},
		{
			path: "/classes",
			name: "ClassList",
			component: ClassList,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/class_details",
			name: "ClassDetails",
			component: ClassDetails,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher],
				prefillContext: true,
			}
		},
		{
			path: "/portfolio",
			name: "Portfolio",
			component: Portfolio,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/profile/:assignmentID",
			name: "Profile",
			component: Profile,
			props: initProps,
			meta: {
				access: [RoleStudent]
			}
		},
		{
			path: "/profile_results",
			name: "ProfileList",
			component: ProfileList,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner]
			}
		},
		{
			path: "/profile_entry",
			name: "ProfileEntry",
			component: ProfileEntry,
			props: initProps,
			meta: {
				access: [RoleStudent]
			}
		},
		{
			path: "/profile_results/:userID",
			name: "ProfileResults",
			component: ProfileResult,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner]
			}
		},
		{
			path: "/profile_result/:assignmentID",
			name: "ProfileResult",
			component: ProfileResult,
			props: initProps,
			meta: {
				access: [RoleStudent]
			}
		},
		{
			path: "/profile_result/:userID/:assignmentID",
			name: "UserProfileResult",
			component: ProfileResult,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner]
			}
		},
		{
			path: "/pitch_entry",
			name: "PitchEntry",
			component: PitchEntry,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/pitches",
			name: "Pitches",
			component: Pitches,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/pitches/:sectionID",
			name: "Pitches",
			component: Pitches,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/pitch/:teamID/:assignmentID",
			name: "Pitch",
			component: Pitch,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/pitch/:pitchID",
			name: "PitchSubmission",
			component: PitchSubmission,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/prototype/:pitchID",
			name: "PitchSubmission",
			component: PitchSubmission,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/upload_pitch",
			name: "UploadPitch",
			component: UploadPitch,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/prototype_entry",
			name: "PrototypeEntry",
			component: PrototypeEntry,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/prototypes",
			name: "Prototypes",
			component: Pitches,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/prototypes/:sectionID",
			name: "Prototypes",
			component: Pitches,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/prototype/:teamID/:assignmentID",
			name: "Prototype",
			component: Pitch,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/upload_prototype",
			name: "UploadPrototype",
			component: UploadPitch,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/canvas",
			name: "InnovationCanvas",
			component: InnovationCanvas,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/canvases",
			name: "Canvases",
			component: Canvases,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner]
			},
		},
		{
			path: "/canvases/:sectionID",
			name: "Canvases",
			component: Canvases,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			},
		},
		{
			path: "/canvas/:canvasID",
			name: "CanvasSubmission",
			component: CanvasSubmission,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			},
		},
		{
			path: "/canvas_edit",
			name: "CanvasEdit",
			component: CanvasEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/canvas_feedbacks",
			name: "CanvasFeedback",
			component: CanvasFeedback,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr",
			name: "TVREntry",
			component: TVREntry,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr_picker",
			name: "TVRPicker",
			component: TVRPicker,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr_form/:assignmentID/:recipientID",
			name: "TVRForm",
			component: TVRForm,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr_results",
			name: "TVRResults",
			component: TVRResults,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr_feedbacks",
			name: "TVRFeedbacks",
			component: TVRFeedbacks,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/tvr_feedback/:assignmentID/:recipientID",
			name: "TVRFeedback",
			component: TVRFeedback,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/video",
			name: "Video",
			component: Video,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/exam",
			name: "ProficiencyExam",
			component: ProficiencyExam,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/pitch_progress",
			name: "PitchProgress",
			component: PitchProgress,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},
		{
			path: "/prototype_progress",
			name: "PrototypeProgress",
			component: PrototypeProgress,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent]
			}
		},
		{
			path: "/account",
			name: "UserAccountEdit",
			component: UserAccountEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher, RolePartner, RoleStudent, RoleJudge]
			}
		},

		{
			path: "/admin",
			name: "AdminLanding",
			component: AdminLanding,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/users",
			name: "UserListing",
			component: UserListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/users/:id",
			name: "UserEdit",
			component: UserEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},

		{
			path: "/districts",
			name: "DistrictListing",
			component: DistrictListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/districts/:id",
			name: "DistrictEdit",
			component: DistrictEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},

		{
			path: "/activity",
			name: "ActivityListing",
			component: ActivityListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},

		{
			path: "/programs",
			name: "ProgramListing",
			component: ProgramListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/programs/:id",
			name: "ProgramEdit",
			component: ProgramEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},

		{
			path: "/schools",
			name: "SchoolListing",
			component: SchoolListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/schools/:id",
			name: "SchoolEdit",
			component: SchoolEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},

		{
			path: "/sections",
			name: "SectionListing",
			component: SectionListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/sections/:id",
			name: "SectionEdit",
			component: SectionEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/contests",
			name: "ContestListing",
			component: ContestListing,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/contests/:id",
			name: "ContestEdit",
			component: ContestEdit,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/score",
			name: "ScorePortfolios",
			component: ScorePortfolios,
			props: initProps,
			meta: {
				access: [RoleAdmin]
			}
		},
		{
			path: "/uploader_test",
			name: "UploaderTest",
			component: UploaderTest,
			props: initProps,
			meta: {
				access: [RoleAdmin, RoleTeacher]
			}
		}
	]
});

function initProps(route) {
	let props = {
		params: route.params,
		query: route.query
	};

	if (!(route.meta && route.meta.props)) {
		return props
	}
	console.log("INIT PROPS", route.meta.props)
	for (let key in route.meta.props) {
		let prop = route.meta.props[key]
		console.log("SET", key, "TO", prop)
		props[key] = prop
	}

	return props;
}

router.beforeEach((to, from, next) => {
	console.log("---- Routing '" + to.path + "' to " + to.name + " ----", to);

	if (!to.meta.access) {
		// External route, allow without getting/loading user
		next()
		return
	}

	to.meta.props = {}

	AuthService.getUser(true)
		.then(data => {
			var user = data.user;
			console.log("GOT RESP", data);
			to.meta.props.user = data.user;

			if (!hasAccess(to, user)) {
				console.log(to);
				Notie.info(
					`<h4>You are not allowed here!</h4><div class="text-muted">${to.path}</div>`
				);
				next(false);
				return
			}

			if (!to.meta.prefillContext) {
				next()
				return
			}

			// Load fully prefilled context if that is specified for this path
			SectionService.getContextPrefilled().then(r => {
				to.meta.props.user.context = r.data
				next()
			}).catch(e => {
				console.log(e);
				Notie.info("<h4>You are not in a class</h4>");
				next("/");
			})
		})
		.catch(e => {
			console.log(e);
			Notie.info("<h4>You are not logged in</h4>");
			next("/");
		});
});

// function allowsExternalAccess(route) {
// 	return route.meta && route.meta.access == "external";
// }

// function hasAccess(route, user) {
// 	if (route.meta && route.meta.access && route.meta.access.length) {
// 		return route.meta.access.includes(user.role);
// 	}

// 	console.error(`Route ${route.path} has no defined access`);
// 	return false;
// }



function hasAccess(route, user) {
	console.log("HASACCESS", route, user)
	if (route.meta && route.meta.access && route.meta.access.length) {
		return route.meta.access.includes(user.role);
	}

	console.error(`Route ${route.path} has no defined access`);
	return false;
}

export default router;
